import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '../../../../../../ui-kitchen/src/utils/sanitizeString';
import './AmexEventImagePreview.scss';

const AmexEventImagePreview = (
  {
    date = '',
    previewContent = {},
  }
) => {
  if (!date && Object.keys(previewContent).length === 0) return null;
  const [previewData, setPreviewData] = useState({});

  const formatDate = () => {
    moment.tz.setDefault('America/New_York');
    const isValidDate = moment(date, true).isValid();
    if (isValidDate) {
      const previewDate = {
        line_1: `${moment(`${date}`).format('MMM')}`,
        line_2: `${moment(`${date}`).format('D')}`,
      };
      return setPreviewData(previewDate);
    }
    return {};
  };

  const renderPreview = () => {
    const isEmpty = Object.values(previewData).every((val) => val === null || val === '');
    if (Object.keys(previewData).length === 0 || isEmpty) return null;
    const filteredPreviewEntries = Object.entries(previewData)
      .filter(([value]) => !!value);
    const previewConfig = Object.fromEntries(filteredPreviewEntries);
    const finalPreviewConfig = Object.values(previewConfig).slice(0, 3);
    const previewLength = finalPreviewConfig.length;
    return (
      <p
        className={`AmexEventImagePreview__badge items-${previewLength}`}
        aria-hidden="true"
      >
        {finalPreviewConfig.map((line) => {
          const sanitizedLine = sanitizeString(line);
          return (
            <span
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: sanitizedLine,
              }}
            />
          );
        })}
      </p>
    );
  };

  useEffect(() => {
    if (Object.keys(previewContent).length > 0) setPreviewData(previewContent);
    if (date) formatDate();
  }, []);

  return (
    <div className="AmexEventImagePreview">
      {renderPreview()}
    </div>
  );
};

AmexEventImagePreview.propTypes = {
  date: PropTypes.string,
  previewContent: PropTypes.shape({}),
};

AmexEventImagePreview.defaultProps = {
  date: '',
  previewContent: {},
};

export default AmexEventImagePreview;
